import React, { useEffect } from 'react'

import {
  DataTable,
  PARAM_ORDER_ASC,
  PARAM_ORDER_DESC,
  NoResults,
  SpacingVertical,
  SPACING_8,
  TooltipUtils
} from 'mailup-web-components'

import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import {
  fixedFieldsState,
  manageableFieldsState,
  recipientsDataTablePreviewState,
  visibleColumnsState
} from 'Pages/EmailSendingWizard/recoil/state/searchCriteria'
import { searchRecipientsDataCallback } from 'Pages/EmailSendingWizard/recoil/callbacks/callback'
import { useIntl } from 'react-intl'

const DataTablePreview = () => {
  const intl = useIntl()

  const visibleColumns = useRecoilValue(visibleColumnsState)

  const manageableFields = useRecoilValue(manageableFieldsState)
  const fixedFields = useRecoilValue(fixedFieldsState)

  const [
    { items, sortBy, sortOrder, sortChanged, firstChange },
    setRecipientState
  ] = useRecoilState(recipientsDataTablePreviewState)

  const searchRecipientsData = useRecoilCallback(
    searchRecipientsDataCallback,
    []
  )

  const handleClickSort = newSortBy => {
    let newSortOrder = sortOrder

    if (sortBy === newSortBy) {
      newSortOrder =
        sortOrder === PARAM_ORDER_DESC ? PARAM_ORDER_ASC : PARAM_ORDER_DESC
    }

    setRecipientState(prev => ({
      ...prev,
      sortBy: newSortBy,
      sortOrder: newSortOrder,
      sortChanged: true
    }))
  }

  useEffect(() => {
    if (sortChanged) {
      searchRecipientsData()
      setRecipientState(prev => ({
        ...prev,
        sortChanged: false
      }))
    }
  }, [sortChanged])
  const manageableColumns = visibleColumns.map(id => ({
    sortId: typeof id === 'number' ? `Field${id}` : id,
    content: manageableFields.find(field => field.id === id).description,
    sortable: true,
    truncate: true
  }))

  const fixedColumns = fixedFields
    .filter(c => !visibleColumns.includes(c.id))
    .map(({ id, description }) => ({
      sortId: id,
      content: description,
      sortable: true,
      truncate: true
    }))

  const columns =
    manageableColumns.length > 0 ? manageableColumns : fixedColumns

  const getBodyRow = item => {
    const rows = []
    columns.forEach(e => {
      if (e.sortId === 'Email') {
        rows.push({ content: item.Email })
      } else if (e.sortId === 'MobilePrefixAndNumber') {
        rows.push({
          content: `${item.MobilePrefix} ${item.MobileNumber}`
        })
      } else {
        const fieldContent = item.Fields.find(r => `Field${r.Id}` === e.sortId)
        rows.push({
          content: fieldContent ? fieldContent.Value : ''
        })
      }
    })
    return rows
  }

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [columns])

  return (
    <>
      <SpacingVertical variant={SPACING_8} />
      {items && items.length > 0 ? (
        <>
          <DataTable
            sortable
            sortBy={sortBy}
            sortOrder={sortOrder}
            onClickSort={handleClickSort}
            head={[...columns]}
            body={items.map(item => getBodyRow(item))}
            rows={items.length}
          />
          <SpacingVertical />
        </>
      ) : (
        !firstChange && (
          <>
            <NoResults
              text={intl.formatMessage({
                id: 'Load.SearchRecipients.noResultsTitleNew'
              })}
            />
          </>
        )
      )}
    </>
  )
}

export default DataTablePreview
